import { useLocation, useSearchParams } from 'react-router-dom';

export const useWebInterface = () => {
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const view = location.pathname.split('/')[1];

	return {
		connection: searchParams.get('connection') || 'socket',
		port: searchParams.get('port') || '8081',
		url: searchParams.get('address') || 'avss.aceworks.ai',
		view: view === 'passenger' ? 'passenger' : 'driver',
		rate: searchParams.get('rate') || '30',
		secure: searchParams.get('secure')
			? searchParams.get('secure') === 'true'
			: true,
	};
};
